/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sentenceCase'
})

export class SentenceCasePipe implements PipeTransform {
    public transform(text: string): string {
        if (!text) {
            return text;
        }

        const words = text.split(' ');
        let setUpper = true;
        const sentence = [];
        for (const word of words) {
            let newWord: string;
            if (setUpper) {
                newWord = word[0].toUpperCase() + word.substring(1).toLowerCase();
                setUpper = false;
            } else {
                newWord = word.toLowerCase();
            }

            if (word.endsWith('.')) {
                setUpper = true;
            }

            sentence.push(newWord + ' ');
        }

        return sentence.join('');
    }
}
